import React, { useState } from 'react';
import {
    PlusOutlined
} from '@ant-design/icons';
import {
    Button,
    Form,
    Modal,
    Row,
    Col,
    InputNumber,
    message,
    Input,
    DatePicker,
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import axios from '../../../config/axios';

function AddCashDoc({ orderData }) {
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const queryClient = useQueryClient();

    const { isLoading, mutate } = useMutation({
        mutationFn: data => {
            axios
                .post('/api/cashdoc/', data)
                .then(res => {
                    // console.log("create customer :",res);
                    messageApi.open({
                        type: 'success',
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration: 1,
                        onClose: () => {
                            form.resetFields();
                            queryClient.invalidateQueries([`/api/transaction/${orderData._id}`]);
                            setOpen(false);
                        }
                    });
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });

    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate({ ...values, transaction: orderData._id }))
            .catch(err => {
                console.log(err)
                messageApi.open({
                    type: 'error',
                    content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                });
            })
    };

    const onCancelCreate = () => {
        setOpen(false);
    }

    // console.log(orderData);
    return (
        <div>
            {contextHolder}
            <Row justify="end">
                <Col>
                    <Button
                        type='primary'
                        icon={<PlusOutlined />}
                        onClick={() => setOpen(true)}
                    >เพิ่มเอกสารการเงิน</Button>
                </Col>
            </Row>
            <Modal
                open={open}
                title="บันทึกข้อมูลเช็ค"
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        ยกเลิก
                    </Button>,
                    <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                        ตกลง
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name='addCheque'
                    initialValues={{
                        pay:'บริษัท ธงชัย ไอที เซ็นเตอร์ จำกัด',
                        doc_date:dayjs()
                    }}
                >
                    <Form.Item
                        name="doc_no"
                        label="เช็คเลขที่"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกข้อมูล',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="pay"
                        label="จ่าย"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกข้อมูล',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="doc_date"
                        label="วันที่"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกข้อมูล',
                            },
                        ]}
                    >
                        <DatePicker style={{ width: "100%" }} format={'DD-MM-YYYY'} />
                    </Form.Item>
                    <Form.Item
                        name="bank_name"
                        label="ธนาคาร"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="bank_branch"
                        label="สาขา"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="the_sum_of"
                        label="จำนวนเงิน"
                    >
                        <InputNumber min={0} style={{ width: '100%' }} />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    )
}

export default AddCashDoc